const re =
  /^((\b([1-9]|[1-8][0-9]|9[0-9]|[1-9][0-9]{2}|100[0-3])\b)|(\b([1-9]|[1-8][0-9]|9[0-9]|[1-9][0-9]{2}|100[0-3])\b)\.|1\.([5-9]|[5][8][7-9]|[5][8-9]|[5][9][0-9]|[6-9][0-9]|[6-9][0-9][0-9]|(587[5-9]|58[89][0-9]|59[0-9][0-9]|[6-9][0-9][0-9][0-9]))?|(\b([1-9]|[1-8][0-9]|9[0-9]|[1-9][0-9]{2}|100[012])\b)\.([0-9]|[0-9][0-9]|[0-9][0-9][0-9]|[0-9][0-9][0-9][1-9])?|1003\.(([0-2]|[0-2][0-9]|[0-2][0-9][0-9]|[0-2][0-9][0-9][0-9])|3?)?)?$/gi

const mmValidator = (input) => String(input).match(re)

export default mmValidator
